import FizConfig from "../FizConfig.js";
import * as Html from "../util/Html.ts";
import * as Locale from "../util/Locale.js";
import {searchCallback} from "../lib/giphyapi.js";
import * as progressbar from "../util/progressbar.ts";
import TPL_postgiflist from "../form/post-gif-list.mustache";

export {init}
Html.registerWidget('widget/giphy',{init:init})
  
Html.register({
  pickgif:function(url,preview){
    var 
      form = this.parents("form"),
      giphyPreview = form.find("[data-widget='widget/giphy-preview']"),
      textarea = form.find("textarea").get(0);
    if(giphyPreview.length){
      giphyPreview.trigger("change",{url:url,preview:preview})
    }else{
      textarea.value = url;
      form.submit();
    }
    return false;
    
  }
})
var 
  lastSearch = '',
  lastResponse = null;

function dispatch(gifs){
  var cols = [[],[]];
  cols.forEach(function(column){
    column.height=0;
  })
  gifs.forEach(function(gif){
    var col = cols[0].height<cols[1].height?cols[0]:cols[1];
    col.push(gif);
    col.height = col.height+gif.image.height + 6;
    //preload in good order
    (new Image()).src=gif.image.url;

  });
  var shortCol = cols[0].height<cols[1].height?cols[0]:cols[1];
  shortCol.shortest = true;
  return cols;
}

function search(node,q){
  lastSearch = q;
  var targetNode = node.find('.giphy-img'); 
  var pg = progressbar.standard
  searchCallback(function(response){
    lastResponse = response;
    
    var 
      gifs = response.data,
      cols = dispatch(gifs);
    
    if(gifs.length){
      Html.setHtml(targetNode,TPL_postgiflist,{gif:gifs,column:cols});
    }
    pg.close()
    
  },
  function(){pg.close()},
  q,
  FizConfig.GIPHY_API_KEY,Locale.get().substring(0,2).toUpperCase())
}

var timeout;
function searchlimiter(node,q){
  clearTimeout(timeout);
  timeout = setTimeout(function(){
    if(q!=lastSearch){
      search(node,q)
    }
  },350);
}
function nextlimiter(){
  var targetNode = $(this).find('.giphy-img'); 
  clearTimeout(timeout);
  timeout = setTimeout(function(){
    lastResponse.next(function(response){
      lastResponse.data = lastResponse.data.concat(response.data);
      lastResponse.next = response.next;
      
      var 
        gifs = lastResponse.data,
        cols = dispatch(gifs);
      
      if(gifs.length){
        Html.setHtml(targetNode,TPL_postgiflist,{gif:gifs,column:cols});
      }
      
    });
  },350);
}

function init(obj){
  obj.find('form').on('submit click',function(evt){
    evt.stopPropagation();
    evt.preventDefault();
  })
  obj.find('input').on('keyup keydown change',function(evt){
    evt.stopPropagation();
    if(evt.which===13){
      evt.preventDefault();
    }
    searchlimiter(obj,this.value);
  }).val(lastSearch).focus();
  obj.on('endintoview',nextlimiter);
  search(obj,lastSearch);
}